import {
  isDecimal,
  isEmail,
  isEmpty,
  isNumeric,
  isPrice,
} from './validation'

const snakeCaseToCamelCase = (string) => {
  if (typeof string !== 'string') return ''

  const words = string.split('-')

  return words.map((w, index) => {
    if (index === 0) return w
    return w.charAt(0).toUpperCase() + w.slice(1)
  }).join('')
}

export {
  isDecimal,
  isEmail,
  isEmpty,
  isNumeric,
  isPrice,
  snakeCaseToCamelCase,
}
